module.exports = function (callback) {
    if (typeof customElements !== "undefined") {
        callback();
    }
    else {
        window.cian_cd_compatibility_mode = true;
        Number.parseFloat = parseFloat;
        Number.parseInt = parseInt;
        if(!String.prototype.endsWith) {
            String.prototype.endsWith = function (v) {
                var idx = this.indexOf(v);
                return idx === v.length - v.length;
            }
        }
        // проверяем поддержку
        if (!Element.prototype.matches) {

            // определяем свойство
            Element.prototype.matches = Element.prototype.matchesSelector ||
                Element.prototype.webkitMatchesSelector ||
                Element.prototype.mozMatchesSelector ||
                Element.prototype.msMatchesSelector;

        }
        // проверяем поддержку
        if (!Element.prototype.closest) {

            // реализуем
            Element.prototype.closest = function(css) {
                var node = this;

                while (node) {
                    if (node.matches(css)) return node;
                    else node = node.parentElement;
                }
                return null;
            };
        }
        if (!document.querySelector('script[src="https://unpkg.com/@webcomponents/webcomponentsjs@2.4.3/webcomponents-bundle.js"]')) {
            const v = document.createElement('script');
            v.src = 'https://unpkg.com/@webcomponents/webcomponentsjs@2.4.3/webcomponents-bundle.js';
            document.head.appendChild(v);
        }
        if (!document.querySelector('script[src="https://cdn.jsdelivr.net/npm/promise-polyfill@8/dist/polyfill.min.js"]')) {
            const v = document.createElement('script');
            v.src = 'https://cdn.jsdelivr.net/npm/promise-polyfill@8/dist/polyfill.min.js';
            document.head.appendChild(v);
        }
        if (!document.querySelector('script[src="https://unpkg.com/whatwg-fetch@3.0.0/dist/fetch.umd.js"]')) {
            const v = document.createElement('script');
            v.src = 'https://unpkg.com/whatwg-fetch@3.0.0/dist/fetch.umd.js';
            document.head.appendChild(v);
        }
        const checkLoaded = function() {
            if (typeof customElements === "undefined" || typeof fetch === 'undefined' || typeof Promise === "undefined") {
                setTimeout(checkLoaded, 100);
            } else {
                callback();
            }
        };
        checkLoaded();
    }
};